
class Store {
    protected static readonly SERIALIZE_PREFIX = "__s";

    constructor() {
    }

    public getItem(key: string): any {
        let value = localStorage.getItem(key);
        if (value !== null && value.substr(0, Store.SERIALIZE_PREFIX.length) === Store.SERIALIZE_PREFIX)
            value = this.unserialize(value);
        return value;
    }

    public setItem(key: string, value: any) {
        if (typeof value !== "string")
            value = this.serialize(value); // localStorage only supports strings
        localStorage.setItem(key, value);
    }

    public removeItem(key: string) {
        localStorage.removeItem(key);
    }

    public clear() {
        localStorage.clear();
    }

    public getLength() {
        return localStorage.length;
    }

    public keyName(index: number) {
        return localStorage.key(index);
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected serialize(value: any): string {
        return Store.SERIALIZE_PREFIX + JSON.stringify(value);
    }

    protected unserialize(value: string): any {
        if (value && value.substr(0, Store.SERIALIZE_PREFIX.length) === Store.SERIALIZE_PREFIX)
            value = value.substr(Store.SERIALIZE_PREFIX.length);
        return JSON.parse(value);
    }
}

export const store = new Store(); // export a singleton
